// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './styles/_common/index.less'
import './styles/common.less'
import {router} from './router'
import {menuRouters, otherRouters} from './router/router'
import store from './store'
import {ajax} from '@/libs/ajax'
import {mapMutations, mapState} from 'vuex'
import global_ from './libs/global'
import Cookies from 'js-cookie'
import Print from 'vue-print-nb-jeecg'
import htmlToPdf from '@/libs/htmltopdf'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import md5 from 'js-md5'
import 'babel-polyfill'

Vue.config.productionTip = false
Vue.prototype.GLOBAL = global_
Vue.prototype.$md5 = md5

Vue.use(ViewUI, {
  select: {
    arrow: 'ios-arrow-down',
    arrowSize: 20
  },
  datePicker: {
    iconSize: 20
  }
})
Vue.use(Print)
Vue.use(htmlToPdf)
Vue.use(Viewer, {
  defaultOptions: {
    button: false,
    navbar: false,
    toolbar: false,
    title: false,
    className: 'viewerClass'
  }
})

// 加载localStorage中的数据
function loadStorageData () {
  // 加载localStorage中的数据
  const user = JSON.parse(localStorage.getItem('user')) || {}
  store.commit('user/setUser', user)
}

loadStorageData()

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: {
    currentPageName: ''
  },
  computed: {
    ...mapState('user', ['user'])
  },
  mounted () {
    // 单点登录
    let user = localStorage.getItem('user')
    // 兼容智能网联交管平台
    let tokenUrl = window.location.search.replace(/\?gwToken=([A-Za-z0-9]+)[&/]?/, '$1')
    if (tokenUrl) {
      let expires = new Date(new Date().getTime() + 1800 * 1000)
      Cookies.set('TTOKEN', tokenUrl, { expires })
      window.location.href = window.location.origin
      return
    }
    let tokenBrowser = Cookies.get('TTOKEN')
    if (!user || tokenBrowser) {
      ajax.post('/auth/login-user-info').then(res => {
        const result = res.data
        if (global_.checkGetwayCode(result.code)) {
          Cookies.set('account', this.$md5('admin'))
          // Cookies.set('password', this.$md5(this.form.password))
          let user = result.data
          ajax.post('/auth/permissions').then(response => {
            const result1 = response.data
            if (this.GLOBAL.checkGetwayCode(result1.code)) {
              user.authorities = result1.data
              localStorage.setItem('user', JSON.stringify(user))
              localStorage.setItem('loginTime', new Date().getTime())

              this.$router.push({
                name: 'HomeIndex'
              })
            }
          })
        } else {
          this.$router.push({
            name: 'login'
          })
        }
      })
    }
    this.currentPageName = this.$route.name
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList')
    this.$store.commit('initCachepage')
    // 权限菜单过滤相关
    // this.$store.commit('updateMenulist', this.user)
    this.$store.commit('changeMenuTheme', 'light')
  },
  created: function () {
    // this.loadStorageData()

    let tagsList = []
    const routers = [...menuRouters, ...otherRouters]
    routers.map((item) => {
      if (item.children.length === 1) {
        tagsList.push(item.children[0])
      } else if (item.children.length > 1) {
        tagsList.push(...item.children)
      }
    })
    this.$store.commit('setTagsList', tagsList)
  },
  methods: {
    ...mapMutations('user', ['setUser', 'logout'])
  }
})

/**
 * 拦截所有ajax请求
 */
ajax.interceptors.response.use(response => {
  if (!(response.data.code === '200' || response.data.code === 10000 || response.data.code === '0000' || response.data.code === '8982' || response.data.code === '0010')) {
    vm.$Message.error(response.data.message || response.data.msg)
  }
  if (response.data.code === '401' || response.data.code === 10104 || response.data.code === '9990' || response.data.code === '9991' || response.data.code === '9992') {
    router.push({name: 'login'})
    return Promise.reject(response)
  }
  // 更新gwToken有效期
  let gwToken = Cookies.get('TTOKEN')
  if (gwToken) {
    let expires = new Date(new Date().getTime() + 1800 * 1000)
    Cookies.set('TTOKEN', gwToken, { expires })
  }
  return response
}, err => {
  if (err.response.status === 401) {
    vm.$Message.error('请重新登录')
    router.push({name: 'login'})
  } else {
    vm.$Message.error(err.response.data.message || err.response.data.msg)
  }
  return Promise.reject(err)
})



// WEBPACK FOOTER //
// ./src/main.js